import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from '../../../components/AdfoxBanner';
import { selectIsAgent } from '../../../selectors';
import { useAdfoxBannerActions } from '../hooks/useAdfoxBannerActions';
import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

const ADFOX_PARAMETERS = {
  p1: 'crtmo',
  p2: 'fkhh',
};

export const TgbAsideBannerContainer: React.FC = () => {
  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );
  const { onClick, onLoad } = useAdfoxBannerActions();

  const handleLoad = React.useCallback(
    ({ bundleParams: { bannerId } }: IAdFoxBannerOnLoadData) => {
      onLoad(bannerId);
    },
    [onLoad],
  );

  return (
    <AdfoxBanner
      disableYan={isAgent}
      params={adfoxParameters}
      minHeight="200px"
      width="100%"
      onLoad={handleLoad}
      onClick={onClick}
    />
  );
};
